import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';
import { finalize } from 'rxjs';

export const InterceptorForSpinner: HttpInterceptorFn = (req, next) => {
    const spinnerService = inject(SpinnerService);

    if (req.headers.has('X-Skip-Spinner')) {
        const headers = req.headers.delete('X-Skip-Spinner');
        return next(req.clone({ headers }));
    }

    spinnerService.showSpinner();

    return next(req).pipe(
        finalize(() => spinnerService.hideSpinner())
    );
};
